import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavdataService{
private dataSubject = new BehaviorSubject<any>(null);
data$: Observable<any> = this.dataSubject.asObservable();

setData(data:any){
    this.dataSubject.next(data);
}

constructor(){
    
}

}